export const getUniqueId = (state) => state.datatableContent.uniqueId;
export const updateOrderLoading = (state) => state.datatableContent.loading;
